import React, { useState } from 'react';
import styled from 'styled-components';
import { BooleanParam, useQueryParam } from 'use-query-params';
import { Icon, IconButton, Menu, MenuItem, Typography } from '@material-ui/core';
import { TreeItem, TreeView } from '@material-ui/lab';
import { AppSnackbar, Panel, PanelContent, PanelHeader } from '@sierralabs/core-ui';
import { FormTemplateCreateDialog, useFormBuilderContext } from '..';
import FormTemplateMenuButton from '../common/menus/FormTemplateMenuButton';
import ImportFormTemplateDialog from '../dialogs/ImportFormTemplateDialog';
const StyledPanel = styled(Panel) `
  .tree-label {
    display: flex;
    align-items: center;
  }
  .more-icon {
    font-size: 18px;
  }
  .deleted-item {
    color: red;
  }
  .flex-end {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    padding: 0 12px 0 6px;
  }
`;
const FormListPanel = () => {
    const [showDeleted, setShowDeleted] = useQueryParam('show-deleted', BooleanParam);
    const [openDialog, setOpenDialog] = useState(false);
    const [openImportDialog, setOpenImportDialog] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [menuAnchor, setMenuAnchor] = useState(null);
    const { formTemplateList, setSelectedForm, findFormTemplates } = useFormBuilderContext();
    const handleFindFormTemplate = () => {
        findFormTemplates({ limit: 1000, includeDeleted: showDeleted });
    };
    return (React.createElement(StyledPanel, { className: 'form-list' },
        React.createElement(PanelHeader, { accessory: React.createElement(IconButton, { size: 'small', onClick: e => setMenuAnchor(e.currentTarget) },
                React.createElement(Icon, { className: 'more-icon' }, "more_vert")) },
            React.createElement(Typography, { variant: 'overline' }, "Forms"),
            React.createElement(Menu, { id: 'form-more-menu', anchorEl: menuAnchor, keepMounted: true, open: Boolean(menuAnchor), getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, onClose: () => {
                    setMenuAnchor(null);
                } },
                React.createElement(MenuItem, { onClick: () => {
                        setMenuAnchor(null);
                        setOpenDialog(true);
                    } }, "Add Form"),
                React.createElement(MenuItem, { onClick: () => {
                        setMenuAnchor(null);
                        setOpenImportDialog(true);
                    } }, "Import Form"),
                React.createElement(MenuItem, { onClick: () => {
                        setShowDeleted(!showDeleted);
                        setMenuAnchor(null);
                    } }, showDeleted ? 'Hide Deleted' : 'Show Deleted'))),
        React.createElement(PanelContent, null, formTemplateList && (React.createElement(TreeView, { defaultCollapseIcon: React.createElement(Icon, null, "arrow_drop_down"), defaultExpandIcon: React.createElement(Icon, null, "arrow_right") }, formTemplateList.data.map(form => (React.createElement(TreeItem, { key: form.id, nodeId: form.id.toString(), className: form.isDeleted ? 'deleted-item' : undefined, label: React.createElement("div", { className: 'tree-label' },
                form.name,
                React.createElement("div", { className: 'flex-end' },
                    React.createElement(FormTemplateMenuButton, { form: form, onUpdate: () => {
                            handleFindFormTemplate();
                            setSuccessMessage('Form updated successfully.');
                        }, onDelete: () => {
                            handleFindFormTemplate();
                            setSuccessMessage('Form deleted successfully.');
                        } }))), onClick: () => {
                if (!form.config) {
                    form.config = {
                        name: form.name,
                        states: [
                            {
                                name: form.name,
                                meta: { title: form.name, elements: [] }
                            }
                        ]
                    };
                }
                setSelectedForm(form);
            } })))))),
        openDialog && (React.createElement(FormTemplateCreateDialog, { open: true, onCancel: () => setOpenDialog(false), onCreated: form => {
                handleFindFormTemplate();
                setSelectedForm(form);
                setOpenDialog(false);
            } })),
        openImportDialog && (React.createElement(ImportFormTemplateDialog, { open: true, onCancel: () => setOpenImportDialog(false), onImport: form => {
                handleFindFormTemplate();
                setOpenImportDialog(false);
                setSuccessMessage(`Imported "${form.name}" Form.`);
            } })),
        React.createElement(AppSnackbar, { severity: 'success', open: !!successMessage, onClose: () => setSuccessMessage('') }, successMessage)));
};
export default FormListPanel;
//# sourceMappingURL=FormListPanel.js.map